import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogDescription,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/Button';

interface Props {
  open: boolean;
  duplicateNames: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function DuplicateConfirmDialog({ open, duplicateNames, onConfirm, onCancel }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent className="w-[640px] max-w-screen-sm p-0">
        {/* ヘッダー */}
        <div className="flex items-center justify-between border-b border-solid border-border px-lg py-md">
          <AlertDialogTitle className="text-heading-xs">
            求職者データの重複があります
          </AlertDialogTitle>
        </div>

        {/* 本文 */}
        <div className="p-lg">
          <AlertDialogDescription className="text-foreground text-body-sm whitespace-pre-line">
            {`以下の求職者が重複しています。\n${duplicateNames.join('\n')}\n\nこのまま取り込むと重複する求職者が保存されます。よろしいですか？`}
          </AlertDialogDescription>
        </div>

        {/* フッター */}
        <div className="flex justify-end gap-md border-t border-solid border-border px-lg py-md">
          <Button color="secondary" size="md" onClick={onCancel}>
            もどる
          </Button>
          <Button color="primary" size="md" onClick={onConfirm}>
            このまま取り込む
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
